import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";


const firebaseConfig = {
  apiKey: "AIzaSyBB6OLFBK0KVQFIeXnytAncQI8MAgW_xYo",
  authDomain: "humanforce-1e3f4.firebaseapp.com",
  projectId: "humanforce-1e3f4",
  storageBucket: "humanforce-1e3f4.firebasestorage.app",
  messagingSenderId: "628310247918",
  appId: "1:628310247918:web:530fb649c13e5400cb26ff",
  measurementId: "G-RRB5TL5BRL"
};


const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
auth.useDeviceLanguage();

const analytics = getAnalytics(app);

export { auth, analytics };